import React, { CSSProperties } from 'react';
import { Theme, withStyles, createStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';

interface CustomTabProps {
  label: string;
}

export const CustomTab = withStyles(({ typography, spacing, palette }: Theme) =>
  createStyles({
    root: {
      color: palette.primary.main,
      fontWeight: typography.fontWeightBold,
      textTransform: 'uppercase',
      marginRight: spacing(1),
      minWidth: 140,
      padding: spacing(2.6, 4),
      lineHeight: 1,
      opacity: 1,
      zIndex: 1,
    },
    selected: {
      color: palette.common.white,
      fontWeight: typography.fontWeightBold,
    },
  })
)((customTabProps: CustomTabProps & { style: CSSProperties }) => (
  <Tab disableRipple {...customTabProps} />
));

export default CustomTab;
